import React, {useEffect, useState} from "react";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {css} from "@emotion/css";
import {MagazineService} from "../../serverService/magazineService/MagazineService";
import {magazineTypes} from "../../pages/magazine/MagazineList";
import {useParams} from "react-router-dom";

import RaikoCustomEditor2 from "../../raikoComponents/raikoEditor/RaikoCustomEditor2";
import NewsDetailCornerstone from "./NewsDetailCornerstone";
import {
    convertPersianDateToUniversalDate,
    convertUniversalDateTimeToPersianDateTime, RaikoAlert, raikoAlertTypes,
    RaikoBaseCardContainer, RaikoButtonPrimary,
    RaikoConfirmDialog, RaikoCreatorInfo, RaikoCustomSelect, raikoCustomSelectItemGenerator, RaikoDatePicker,
    RaikoGridOneColumn, RaikoGridTwoColumn,
    RaikoSectionContainer, RaikoSimpleInputOutlined, RaikoSimpleMultiLineInputOutlined, RaikoToggleOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
} from "@moeindal/base-raiko-panel-components";

export default function NewsDetailBaseInfo(
    {setPageTitle}
) {

    const {id: blogID} = useParams()


    const service = new MagazineService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof blogID !== "undefined" && blogID >= 0) {
            getNewsInfoFromServer()
        }
    }, [blogID]);

    function getNewsInfoFromServer() {
        loading.show()
        service.getNewsGlobalInfo(blogID)
            .then((
                {
                    newsInformation,
                    newsPublished,
                    newsContent
                }) => {
                setDescription(newsContent)
                setNewsInformation(newsInformation)

                setEnabled(newsPublished.published)

                if (newsPublished.publishedAt && newsPublished.publishedAt.length > 0)
                    setPublishedDate(newsPublished.publishedAt)

                loading.hide()
            }).catch(reason => {
            showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت جزئیات محتوا"))
            loading.hide()
        })
    }

    function setNewsInformation(newsInformation) {
        setPageTitle(newsInformation.title)

        setTitle(newsInformation.title)
        setArticleType(newsInformation.type)
        setShortDescription(newsInformation.shortDescription)

        setCreatedAt(convertUniversalDateTimeToPersianDateTime(newsInformation.createdAt))
        setCreatedBy(newsInformation.createdBy)

    }


    const [title, setTitle] = useState("");
    const [articleType, setArticleType] = useState(magazineTypes.ARTICLE.id);
    const [shortDescription, setShortDescription] = useState("");
    const [description, setDescription] = useState([]);
    const [publishedDate, setPublishedDate] = useState("");

    const [createdAt, setCreatedAt] = useState("");
    const [createdBy, setCreatedBy] = useState("");

    const [enabled, setEnabled] = useState(true);

    const [confirmDialogOpenState, setConfirmDialogOpenState] = useState(false);

    function handleCloseConfirmDialog() {
        setConfirmDialogOpenState(false)
    }

    function handleOpenConfirmDialog() {
        setConfirmDialogOpenState(true)
    }

    function checkFields() {
        let message = ""
        let state = false

        if (title === null || title.trim().length === 0)
            message = "لطفا عنوان محتوا را وارد نمایید!"
        else if (shortDescription === null || shortDescription.trim().length === 0)
            message = "لطفا توضیحات کوتاه محتوا را وارد نمایید!"
        else
            state = true

        if (message)
            showWarningMessage(message)

        return state
    }

    function handleUpdateNewsInformation() {
        if (checkFields()) {
            loading.show()
            service.updateNewsInformation(blogID, title, articleType, shortDescription)
                .then(response => {
                    showSuccessMessage("جزئیات محتوا با موفقیت بروزرسانی شد.")
                    loading.hide()
                }).catch(reason => {

                showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی جزئيات محتوا"))
                loading.hide()
            })
        }
    }

    function handleChangeEnableSetting() {
        if (publishedDate) {

            loading.show()

            service.changePublishedState(blogID, !enabled, convertPersianDateToUniversalDate(publishedDate))
                .then(response => {
                    setConfirmDialogOpenState(false)
                    setEnabled(response.published)

                    showSuccessMessage("وضعیت انتشار محتوا با موفقیت تغییر یافت.")
                    loading.hide()
                }).catch(reason => {
                showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در تغییر وضعیت انتشار محتوا."))
                loading.hide()
            })
        } else {
            showWarningMessage("لطفا تاریخ انتشار را انتخاب نمایید.")
        }

    }

    function handleUpdateNewsContent() {
        if (description.length > 0) {
            loading.show()
            service.updateNewsContent(blogID, description)
                .then(response => {
                    showSuccessMessage("متن توضیحات محتوا با موفقیت بروزرسانی شد.")
                    loading.hide()
                }).catch(reason => {
                showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی متن محتوا."))
                loading.hide()
            })
        } else {
            showWarningMessage("لطفا ابتدا توضیحات محتوا را وارد نمایید.")
        }
    }

    function handleUpdatePublishedDate() {


        if (publishedDate) {
            loading.show()

            service.changePublishedState(blogID, enabled, convertPersianDateToUniversalDate(publishedDate))
                .then(response => {

                    showSuccessMessage("تاریخ انتشار محتوا با موفقیت تغییر یافت.")
                }).catch(reason => {
                showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی تاریخ انتشار"))
            }).finally(_ => {
                loading.hide()
            })


        } else {
            showWarningMessage("لطفا تاریخ انتشار را انتخاب نمایید.")
        }
    }

    return (
        <>
            <RaikoConfirmDialog
                openConfirmDialog={confirmDialogOpenState}
                cancelAction={handleCloseConfirmDialog}
                doAction={handleChangeEnableSetting}

                pageTitle={"انتشار محتوا"}
                warningTitle={"آیا از تغییر وضعیت این مورد اطمینان دارید؟"}
                warningDescription={""}
                confirmButtonTitle={!enabled ? "انتشار" : "عدم انتشار"}
            />

            <RaikoGridOneColumn>

                <NewsDetailCornerstone type={articleType} blogID={blogID}/>

                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>

                        <RaikoSectionContainer
                            title={"اطلاعات پایه"}
                            hasActionButton
                            actionButtonOnclick={handleUpdateNewsInformation}
                        >
                            <RaikoGridTwoColumn className={css`margin-top: .5rem`}>
                                <RaikoSimpleInputOutlined
                                    labelText={"عنوان محتوا"}
                                    setValue={setTitle}
                                    value={title}
                                />

                                <RaikoCustomSelect
                                    labelText={"نوع محتوا"}
                                    setValue={setArticleType}
                                    items={[
                                        raikoCustomSelectItemGenerator(magazineTypes.ARTICLE.id, magazineTypes.ARTICLE.title),
                                        raikoCustomSelectItemGenerator(magazineTypes.VIDEO.id, magazineTypes.VIDEO.title),
                                        raikoCustomSelectItemGenerator(magazineTypes.PODCAST.id, magazineTypes.PODCAST.title),
                                        raikoCustomSelectItemGenerator(magazineTypes.PHOTO_GALLERY.id, magazineTypes.PHOTO_GALLERY.title),
                                    ]}
                                    value={articleType}
                                    disabled
                                />
                            </RaikoGridTwoColumn>

                            <RaikoSimpleMultiLineInputOutlined
                                labelText={"توضیحات کوتاه"}
                                setValue={setShortDescription}
                                value={shortDescription}
                            />
                        </RaikoSectionContainer>

                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>

                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoSectionContainer
                            title={"متن مقــاله"}
                            hasActionButton
                            actionButtonOnclick={handleUpdateNewsContent}
                        >
                            <RaikoCustomEditor2
                                value={description}
                                setValue={setDescription}
                            />
                        </RaikoSectionContainer>
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>

                <RaikoCreatorInfo createdBy={createdBy} createdAt={createdAt}/>

                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoSectionContainer
                            title={"وضعیت انتشار"}
                        >
                            <RaikoAlert
                                type={raikoAlertTypes.warning}
                                title={"وضعیت انتشار"}
                                description={[
                                    "* با فعالسازی این مورد کاربران قادر به مشاهده ی این محتوا خواهند بود و در غیر این صورت محتوا تنها به عنوان پیش نویس در پنل مدیریت باقی خواهند ماند.",
                                ]}
                            />
                            <div
                                className={css`
                                  display: flex;
                                  flex-wrap: nowrap;
                                  gap: .5rem;
                                  width: 100%;
                                  flex-grow: 1;

                                  > div {
                                    width: 100%;
                                    flex-grow: 1;
                                  }
                                `}>
                                <RaikoDatePicker date={publishedDate} setDate={setPublishedDate}
                                                 label={"تاریخ انتشار"}/>
                                <RaikoButtonPrimary label={"بروزرسانی"} className={css`height: 54px;
                                  align-self: end`} onClick={handleUpdatePublishedDate}/>
                            </div>
                            <RaikoToggleOutlined
                                labelText={"انتشار (منتشر شده / در انتظار انتشار)"}
                                setChecked={state => {
                                    handleOpenConfirmDialog()
                                }}
                                checked={enabled}
                            />
                        </RaikoSectionContainer>
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>


            </RaikoGridOneColumn>
        </>
    )
}